import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'

import axios from "axios";
import $ from 'jquery';
import tabler from './nlp/tabler_adl.js';
import frm from './formAux.js'
import './nlp/tabler.css';
import './panel.css';
import MD5 from "crypto-js/md5";

// import './jquery-simple-upload.css';
// import '@kanety/jquery-simple-upload';

function px(v) { return v+'px'; }
function pc(v) { if( v < 0 ) v = 0; if( v > 100 ) v = 100; return Math.round(v)+'%'; }
function val(v) { v = parseFloat(v); if( isNaN(v) ) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring( o ){ return typeof(o) == 'string';}
function isarray( o ){ return o instanceof Array;}
function isobj( o ){ return o instanceof Object;}
function isnumber( o ){ return typeof(o) == 'number' && !isNaN(o);}
function defined( o ){ return typeof(o) != 'undefined';}
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec(){	return new Date().getTime(); }
function getsec(){ return Math.round(getmsec()/1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig,'').toLowerCase() }
function iarray( v, n )
{
	var ret = [];
	for( var i = 0 ; i < n ; i++ )
	ret.push( v instanceof Object ? clone(v) : v );
	return ret;
}

function bool( s )
{
	if( typeof(s) == 'boolean' ) return s;
	if( !defined(s) || s === null ) return false;
	if( typeof(s) == 'number' ) return s > 0;
	if( s.match(/^y/i) ) return true;
	return false;
}

function sbool( v )
{
	return ['No','Yes'][v];
}

var companyList = [];
function getCompanies( callback )
{
	if( companyList.length ) callback( companyList )
	window.post( 'find_companies', {match:{active:true}}, function(res){
		if( res.status ) companyList = res.data.records;
		console.log( 'companyList', companyList );
		callback( companyList );
	})
}


function getDatasets( company, callback )
{
	window.post( 'find_file_datasets', {match:{"company":company,active:true}}, function(res){
		var dsList = [];
		if( res.status ) dsList = res.data.records;
		console.log( 'dsList', dsList );
		callback( dsList );
	})
}
async function doAction( act ) {
	var msgs = {
		'delete': '<b>Delete</b> ' + nselected + ' selected tasks?',
	}

	var confs = {
		'delete': 'delete',
		'upload': null,
	}

	if( confs[act] ) if( !await frm.myConfirm('Action', msgs[act], confs[act], 'Ok', 'Cancel') ) return;
	if( act == 'upload' ) await submitFiles( true )
	UFILES = UFILES.filter( f => !selectedUploads[f.ETag]);
	drawTable();
}
function actionPopup(ev) {
	var mpos = $('.maincontent').position();
	var pos = $('#actionButton').position();

	var top = mpos.top + pos.top + $('#actionButton').outerHeight();
	var left = mpos.left + pos.left + parseInt($('.maincontent').css('marginLeft'));
	var width = 280;
	var actionPanel = $('<DIV>').addClass('user-panel').css({ top: top, left: left, width: width });
	actionPanel.append($('<DIV>').html('<i class="fa fa-upload"></i> Upload selected files (' + nselected + ')').on('click', function () { doAction('upload') }));
	actionPanel.append($('<DIV>').html('<i class="fa fa-trash"></i> Delete selected files (' + nselected + ')').on('click', function () { doAction('delete') }));
	// if( window.GlobalVars.userRoles.length > 1 ) actionPanel.append($('<DIV>').html('<i class="fa fa-user-circle"></i> Change role').on('click', function () { window.goPage('userRole') }));
	setTimeout(function () {
		$(document.body).on('click', hideAction);
		$(document.body).append(actionPanel);

		function hideAction() {
			actionPanel.remove();
			$(document.body).off('mousedown');
		}
		console.log('actionPopup', top, left)
	}, 100);
}

async function uploadFile(file, params, callback) {
	let _p_callback = callback;
	return new Promise(async (resolve, reject) => {
		let callback = function () {
			if (_p_callback) _p_callback.apply(this, arguments);
			resolve.apply(this, arguments);
		}

		const xhr = new XMLHttpRequest();
		const formData = new FormData();

		// Append file to FormData object
		formData.append('file', file);
		let url = window.postURL('upload_file_dataset');
		if (!params) params = {};
		if (!callback) callback = function () { }
		params = window.postParams(params);
		for (let i in params) {
			formData.append(i, params[i]);
		}

		xhr.onreadystatechange = function () {
			if (xhr.readyState === 4) {
				if (xhr.status === 200) {
					var res = null;
					try {res = JSON.parse(xhr.response)}
					catch(e) { console.error(e) }
					// File upload success
					console.log('File uploaded successfully', xhr);
					callback(res);
				} else {
					// File upload failed
					console.error('File upload failed');
					callback({status:0,value:'File upload failed'});
				}
			}
		};
		xhr.open('POST', url, true);
		xhr.send(formData);
	});
}

async function submitFiles( selected ){
	if( !UFILES.length ) return frm.myAlert('File Upload', 'Please select and add files to be uploaded');
	console.log( UFILES )

	frm.myAlert('File Upload', 'Uploading file(s). Please wait.');
	$('#modal-close').hide();
	let exportProgress = new frm.progressBar($('.modal-body'));

	let nfiles = 1;
	let did = window.GlobalVars.currentDataset.datasetId;
	let flist = UFILES;

	if( selected ) flist = UFILES.filter( f => selectedUploads[f.ETag]);
	//AQUI
	let error = false;
	// console.log( 'FLIST', flist ); flist = [];
	for( let f of flist ) {
		let progress = nfiles++/UFILES.length;
		exportProgress.set(progress)
		if( f.type.match(/local/i)) {
			var s = await uploadFile( f.fileObj, {datasetId:did} );
		}
		else if( f.fileObj.text || f.type.match(/(s3|url)/i)) {
			let io = {source:f.name};
			if( f.fileObj.text ) {
				io = {text:f.fileObj.text}
			}
			if( f.metadata ) io.metadata = f.metadata;
			let p = {datasetId:did, items:[io]};
			console.log( 'add_dataset_items', JSON.stringify(p) )
			var res = await window.post('add_dataset_items', p )
			var s = res.data;
		}
		if( !s.status ) {
			error = s;
			break;
		}
	}
	await frm.myAlertClose();
	if( error ) {
		frm.myAlert('File Upload Error', error.value );
	}
	else {
		let files = flist.length == 1 ? ' file' : ' files';
		frm.myAlert('File Upload', 'Upload complete. ' + flist.length + files + ' added to the Dataset.');
	}
	if( selected ) return;
	UFILES = [];
	drawTable();
	// window.goPage('datasetItems')
	// alert('submit files')
}


let UFILES = [];
let selectTid = null;
function addFile( fobj ) {
	// console.log( 'aaaaaaaaaaaaaaaaaaaaaaa',fobj )
	window.tab = tab;
	if( 1 ) {
		let t = [fobj.name,fobj.lastModified,fobj.size];
		let ETag = fobj.ETag || MD5( JSON.stringify(t) ).toString();
		console.log( 'addFile', fobj, JSON.stringify(t), ETag )
		if( !UFILES.find( u => u.ETag == ETag ) ) {
			let file = {
				ETag: ETag,
				type: fobj.type,
				name: fobj.name,
				size: fobj.size,
				lastModified: fobj.lastModified,
				fileObj: fobj,
				metadata: fobj.metadata,
			}
			if( fobj.type != 'S3 File' && fobj.type != 'URL File' && fobj.type != 'Plain Text') file.type = 'Local File';
			UFILES.push( file )
			tab.addRow(file, tabClick );
			clearTimeout( selectTid );
			selectTid = setTimeout( function(){
				tabSelect(selectedUploads)
			}, 300 )
		}
		console.log( 'UFILES', UFILES )
	}
}

function tabClick( col, row ) {
	console.log('tabler click', col, row)
}

var tab = null;

var selectedUploads = {};
var nselected = 0;
function tabSelect(selectData) {
	selectedUploads = selectData;
	nselected = UFILES.filter(f => selectedUploads[f.ETag]).length;
	if (nselected) {
		$('#actionButton').html('Actions (' + nselected + ') <i class="fa fa-caret-down"></i>').show();
	}
	else {
		$('#actionButton').hide();
	}
	console.log('tabSelect', selectedUploads, nselected);
}


function drawTable() {
	$('#documentlist').html('')
	var desc = {
		title: 'Upload Files',
		columns: {
			// project: 'Project',
			// name: 'File Name',
			type: 'Type',
			// fileId:'fileId',
			name: 'File Name',
			size: 'Size',
			lastModified: 'Last Modified'
		},
		selectMode: true,
		selectId: 'ETag',
		filter: true,
		search: true,
		sort: true,
		initialSort: 'name',
		initialSortDir: -1,
		pageSize: 20,
		noFilter: {
			// nSubmit: 1,
			// touched: 1,
			// thumb:1,
		},
		noFilter: { lastModified: 1, size:1 },
		noSort: null,
		centerCol: [],
		format: tabler.formatString,
		forceType: { size: 1, lastModified: 1 },
		formatCol: {
			lastModified: tabler.formatDate
		}
		// clickCol: ['stateLabel','source'],
	}
	console.log('desc table', desc)
	// let meta = {};
	// console.log('ufilez', UFILES.length)
	// for(let file of UFILES){
	// 	console.log('filex', file)
	// 	meta = {...meta, ...file.metadata}
	// 	for(let k in file.metadata) file[k] = file.metadata[k]
	// }
	// console.log('metamtb', meta)
	// for(let k in meta) desc.columns[k] = k;

	tab = tabler.table($('#documentlist'), desc, '');
	for( let file of UFILES ) tab.addRow(file, tabClick );
	tab.onSelect(tabSelect)
	// tab.onUpdate(tabUpdate);
	tabRedraw();
}
function tabRedraw(){
	tab.draw();
	// console.log('tabx', tab)
	if(!tab.baseRows) return 
	
	let descriptor = tab.descriptor;

	for( let r of tab.baseRows ) {
		/// get the fileObject stored in the tab rows
		let file = r.data.fileObj;

		/// check for file metadata
		if( file.metadata ) {
			for( let k in file.metadata ) {
				/// copy metadata values to the r.data object
				r.data[k] = file.metadata[k];
				/// update tab columns variable to feature metadata
				descriptor.columns[k] = k;
			}
		}
	}
	/// redraw full table
	tab.redraw();
}
window.tabRedraw = tabRedraw;

let setUploadId = 0;
function setUpload( button, attrs, accept, callback )
{
	let fileinputId = 'fileinput'+setUploadId++;
    button = $(button);
    if( button.prop('input') )  button.prop('input').remove();
    var input = $('<input type="file" id="'+fileinputId+'"/>');
	if( !attrs ) attrs = {};
	for( let a in attrs ) {
		input.attr( a, attrs[a] );
	}
    if( accept ) input.attr('accept', accept );
    button.unbind('click').on('click', function(){ input[0].click() })
    button.after(input);
    button.prop('input', input );
    input.css({
        display: 'none',
    });
    input.on('change', function(ev){
        var finpt = ev.target
        if( !finpt.files.length ) return;
		let areg = new RegExp( '('+accept.split(',').join('|')+')$', 'i' );
		let files = Array.from( finpt.files ).filter( f => f.name.match(areg));
		callback( files );
		setTimeout( function(){
			setUpload( button, attrs, accept, callback  );
		}, 100 )
		return;

        var fr = new FileReader();
        console.log( 'FILE', finpt.files[0].name  )
        fr.onload = function()
        {
            var res = fr.result;
            res = res.substring(res.indexOf(',')+1)
            callback( res, finpt.files[0].name );
            setTimeout( function(){
                setUpload( button, attrs, accept, callback  );
            }, 100 )
        }
        fr.readAsDataURL(finpt.files[0]);
    })
}

let descriptor = {};
let ext = null;
let allowed = null;

function getAWSCredentials() {
	return new Promise( async (resolve, reject) => {
		let content = `<div class="awspanel">
		<label htmlFor="awstype" class="">Type</label>
		<select id="awstype" class="mb-4 form-control">
			<option value="global">Use Global IAM Credentials</option>
			<option value="key">AWS Credentials</option>
			<option value="role" id="optrole">Role ARN</option>
		</select>


		<label htmlFor="awsrolearn" class="awstyperole">AWS Role ARN</label>
		<input placeholder="Aws_role_arn" type="text" id="awsrolearn" class="mb-4 form-control awstyperole" />
		<label htmlFor="awsexternalid" class="awstyperole">External Id</label>
		<input placeholder="Aws_external_id" type="text" id="awsexternalid" class="mb-4 form-control awstyperole" />


		<label htmlFor="awskey" class="awstypekey">AWS Access key</label>
		<input placeholder="Aws_access_key_id" type="text" id="awskey" class="mb-4 form-control awstypekey" />
		<label htmlFor="awssecret" class="awstypekey">Secret</label>
		<input placeholder="Aws_secret_access_key" type="text" id="awssecret" class="mb-4 form-control awstypekey" />
		<label htmlFor="awsregion" class="awstypekey">Region</label>
		<input placeholder="Aws_region" type="text" id="awsregion" class="mb-4 form-control awstypekey" />

		<label htmlFor="awsregion">Intermediate S3 Path: (for task processing)</label>
		<input placeholder="Intermediate S3 URL" type="text" id="awsintermediatepath" class="mb-4 form-control" />
		</div>`;
		let awsCreds = (await window.post('get_aws_credentials_options', {})).data;
		frm.myAlert( 'AWS Credentials Needed', content, 'Save Credentials', async (ev) => {
			ev.preventDefault();
			ev.stopPropagation();
			frm.removeInlineErrors();

			descriptor.awsCredentials = {
				awsType: $('#awstype').val().trim(),
				awsRoleArn: $('#awsrolearn').val().trim(),
				awsExternalId: $('#awsexternalid').val().trim(),
				// awsRoleSessionName: $('#awsrolesessionname').val().trim(),
				awsKey: $('#awskey').val().trim(),
				awsSecret: $('#awssecret').val().trim(),
				awsRegion: $('#awsregion').val().trim(),

			}
			descriptor.s3IntermediateUrl = $('#awsintermediatepath').val().trim();
			// alert( descriptor.awsCredentials.awsType )
			if( descriptor.awsCredentials.awsType == 'key') {
				if( !descriptor.awsCredentials.awsKey ) return frm.inlineError($('#awskey'),'You must set the AWS Access Key')// added 19/1 mani
				// return frm.myAlert( 'Save Project', 'You must set the AWS Access Key', 'Ok', function(){ $('#awskey')[0].focus()} );
				if( !descriptor.awsCredentials.awsSecret ) return frm.inlineError($('#awssecret'),'You must set the AWS Secret')// added 19/1 mani
				// return frm.myAlert( 'Save Project', 'You must set the AWS Secret', 'Ok', function(){ $('#awssecret')[0].focus()} );
				if( !descriptor.awsCredentials.awsRegion ) return frm.inlineError($('#awsregion'),'You must set the AWS region')// added 19/1 mani
				//  return frm.myAlert( 'Save Project', 'You must set the AWS region', 'Ok', function(){ $('#awsregion')[0].focus()} );
			}
			else if( descriptor.awsCredentials.awsType == 'role') {
				if( !descriptor.awsCredentials.awsRoleArn ) return frm.inlineError($('#awsrolearn'),'You must set the AWS Role ARN')// added 19/1 mani
				//  return frm.myAlert( 'Save Project', 'You must set the AWS Role ARN', 'Ok', function(){ $('#awsrolearn')[0].focus()} );
				if( !descriptor.awsCredentials.awsExternalId ) return frm.inlineError($('#awsexternalid'),'You must set the AWS External Id')// added 19/1 mani
				// return frm.myAlert( 'Save Project', 'You must set the AWS External Id', 'Ok', function(){ $('#awsexternalid')[0].focus()} );
			}
			if( !descriptor.s3IntermediateUrl ) return frm.inlineError($('#awsintermediatepath'),'You must select a intermediate bucket path')// added 19/1 mani
			frm.myAlertClose();
			frm.loading('Saving AWS Credentials');
			let did = window.GlobalVars.currentDatasetId;
			let res = await window.post('update_dataset_aws_credentials', {datasetId: did, awsCredentials:descriptor.awsCredentials,s3IntermediateUrl:descriptor.s3IntermediateUrl});
			console.log( 'res', res )
			frm.loadingOut();
			if( typeof( res.data ) == 'string') {
				await frm.myAlertClose();
				frm.myAlert('AWS Credentials Needed', res.data )
				return resolve(0);
			}
			let match = {datasetId:did}
			res = await window.post( 'find_datasets', {match:match, getProjects: true} )
			window.GlobalVars.currentDataset = res.data.records[0];
			await window.saveSession();
			resolve(1);
		}, 'Cancel', function(){resolve(0)})
		let ac = descriptor.awsCredentials || {};
		$('#awstype').val(ac.awsType || 'global');
		$('#awsrolearn').val(ac.awsRoleArn);
		$('#awsexternalid').val(ac.awsExternalId);
		// $('#awsrolesessionname').val(descriptor.awsRoleSessionName);
		$('#awskey').val(ac.awsKey);
		$('#awssecret').val(ac.awsSecret);
		$('#awsregion').val(ac.awsRegion);
		$('#awsintermediatepath').val( descriptor.s3IntermediateUrl)

		function awsTypeChange() {
			var type = $('#awstype').val();
			$('.awstyperole').hide();
			$('.awstypekey').hide();
			if( type == 'role' ) $('.awstyperole').show();
			if( type == 'key' ) $('.awstypekey').show();
		}
        $('#awstype').html(awsCreds)
		$('#awstype').on('change', awsTypeChange )
		// $('.project-aws-panel').find()
		frm.convertSelects($('.awspanel'));
		awsTypeChange();
	});
}

async function cloudupload() {
	if( !window.GlobalVars.currentDataset.descriptor.hasAWSCredentials ) {
		let credentials = await getAWSCredentials();
		if( !credentials ) return; 
	}
	let content = `<label htmlFor="cloudurl" class="awstyperole">AWS S3 Path</label>
	<input placeholder="Enter S3 path" type="text" id="cloudurl" class="mb-4 form-control" />`
	frm.myAlert( 'Cloud Import', content, 'Import', async (ev) => {
		ev.preventDefault();
		ev.stopPropagation();
		frm.removeInlineErrors();
		descriptor.bucket = $('#cloudurl').val().trim();
		if( !descriptor.bucket.match(/^s3:\/\//)) return frm.inlineError( $('#cloudurl'), 'Please enter a valid s3: bucket path');
		let did = window.GlobalVars.currentDatasetId;
		frm.loading('Loading bucket path');
		await frm.myAlertClose();
		let res = await window.post('dataset_list_bucket', {datasetId:did, bucketPath: descriptor.bucket})
		console.log( 'RES', res )
		let files = res.data.files;

		files = files.filter( f => f.source.match(allowed));
		if(files.length == 0) frm.myAlert( 'Failed to import', 'Not a compatible file', 'Ok')
		console.log('filex', files)
		for( let f of files ) {
			let fobj = {
				ETag: f.ETag,
				type: 'S3 File',
				name: f.source,
				source: f.source,
				size: f.Size,
				lastModified: Math.floor(new Date(f.LastModified).getTime()),
			}
			addFile( fobj )
			// console.log( 'FILE', fobj.name )
		}
		tabRedraw();	
		frm.loadingOut();

	}, 'Cancel' );
	$('#cloudurl').val( descriptor.bucket || '');
}

async function uploadFileList(content) {
	let lines = content.replace(/\r/g, '').split('\n').filter(v => v > '');
	let data = null;
	let files = [];
	if (data = parseJSON(lines)) {
		// console.log( 'JSON', data)
		for (let d of data) {
			let best = 0;
			let winner = null;
			let key = null;
			for (let f in d) {
				let s = sourceField(d[f].toString())
				if (s && s > best) [best, winner, key] = [s, d[f], f]
			}
			let sourceKey = Object.keys(d).find( v => v.toLocaleLowerCase() == 'source' );
			if( !sourceKey ) sourceKey = key;
			if( sourceKey && sourceField(d[sourceKey].toString()) ){
				let md = {};
				let hasmd = false;
				for( let f in d ) {
					if( f != sourceKey && d[f]) hasmd = md[f] = d[f]; 
				}
				files.push( {
					source: d[sourceKey],
					metadata: hasmd ? md : null,
				})
			}
		}
	}
	else if (data = parseCSV(lines)) {
		console.log( 'CSV', data)
		let lineCols = [];
		for( let d of data ) lineCols.push( d.length );
		console.log( 'lineCols', frm.aUnique(lineCols) )
		lineCols = frm.aUnique(lineCols);
		if( lineCols.length == 1 && lineCols[0] > 1 ) {// same # of columns for all lines
			let header = data.shift();
			let sourceIdx = header.findIndex( h => h.toLocaleLowerCase() == 'source' );
			let textIdx = header.findIndex( h => h.toLocaleLowerCase() == 'text' );
			if( sourceIdx == -1 && textIdx == -1 ) { // if no source header, figure out which is the source by checking for urls
				let counts = [];
				for (let d of data) {
					let best = 0;
					let winner = null;
					let idx = -1;
					for (let i = 0 ; i < d.length ; i++ ) {
						let f = d[i];
						let s = sourceField(f)
						if( s > 0 ) counts[i] = (counts[i] || 0) + s;
					}
				}
				counts = counts.map( (v,i) => ({count:v,idx:i})).sort( (a,b) => b.count - a.count )
				if( !counts.length || !counts[0] || !counts[0].count ) {
					return frm.myAlert('File Upload', 'Could not identify a source data column in the uploaded file');
				}
				sourceIdx = counts[0].idx;
			}
			for( let d of data ) {
				let md = {};
				let hasmd = false;
				for( let i = 0 ; i < d.length ; i++ ) {
					if( i != sourceIdx && d[i] ) hasmd = md[header[i]] = d[i];
				}
				if( textIdx == -1 && !sourceField(d[sourceIdx]) ) continue;
				let fl = {};
				if( sourceIdx >= 0 ) fl.source = d[sourceIdx];
				else if( textIdx >= 0 ) {
					delete md[header[textIdx]];
					fl.text = d[textIdx];
					fl.source = '____text____.txt';
				}
				fl.metadata = hasmd ? md : null;
				files.push( fl );
			}
		}
		else {
			for (let d of data) {
				let best = 0;
				let winner = null;
				for (let f of d) {
					let s = sourceField(f)
					if (s && s > best) [best, winner] = [s, f]
				}
				if (winner) {
					files.push({
						source: winner,
						metadata: null,
					});
				}
			}
		}
	}
	if (files.find(u => u.source && u.source.match(/^s3:\/\//)) && !window.GlobalVars.currentDataset.descriptor.hasAWSCredentials) {
		let credentials = await getAWSCredentials();
		if (!credentials) return;
	}
	files = files.filter( f => f.source.match(allowed));
	if( !files.length ) return frm.myAlert('File Upload', 'No compatible URLs or AWS paths were found in selected file');
	console.log('kik', files)
	for( let f of files ) {
		let fobj = {
			type: f.source.match(/^s3/) ? 'S3 File' : 'URL File',
			name: f.source,
			source: f.source,
			size: '',
			lastModified: '',
			metadata: f.metadata,
		}
		if( f.text ) {
			fobj.name = f.text;
			fobj.source = f.text;
			fobj.text = f.text;
			fobj.type = 'Plain Text';
		}
		addFile( fobj )
		// console.log( 'FILE', fobj.name )
	}
	console.log('uploadFileList URLS', files)
	tabRedraw();	
}

function parseCsvLine(line) {
	const values = [];
	let current = '';
	let inQuote = false;

	for (let i = 0; i < line.length; i++) {
		const char = line[i];
		if (char === ',') {
			if (!inQuote) {
				values.push(current);
				current = '';
				continue;
			}
		} else if (char === '"') {
			inQuote = !inQuote;
		}
		current += char;
	}

	values.push(current);

	// Remove quote characters from each value
	let trimmedValues = values.map(value => value.replace(/^"|"$/g, ''));
	trimmedValues = trimmedValues.map(value => value.replace(/""/g, '"'));

	return trimmedValues;
}

function CSVtoArray(text) {
	return parseCsvLine(text);
	var re_valid = /^\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*(?:,\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*)*$/;
	var re_value = /(?!\s*$)\s*(?:'([^'\\]*(?:\\[\S\s][^'\\]*)*)'|"([^"\\]*(?:\\[\S\s][^"\\]*)*)"|([^,'"\s\\]*(?:\s+[^,'"\s\\]+)*))\s*(?:,|$)/g;
	// Return NULL if input string is not well formed CSV string.
	if (!re_valid.test(text)) return null;
	var a = [];                     // Initialize array to receive values.
	text.replace(re_value, // "Walk" the string using replace with callback.
		function (m0, m1, m2, m3) {
			// Remove backslash from \' in single quoted values.
			if (m1 !== undefined) a.push(m1.replace(/\\'/g, "'"));
			// Remove backslash from \" in double quoted values.
			else if (m2 !== undefined) a.push(m2.replace(/\\"/g, '"'));
			else if (m3 !== undefined) a.push(m3);
			return ''; // Return empty string.
		});
	// Handle special case of empty last value.
	if (/,\s*$/.test(text)) a.push('');
	return a;
};
function parseCSVt(text) {
    // Accepts the full CSV text, not an array of lines!
    const rows = [];
    let row = [];
    let field = '';
    let inQuotes = false;
    let i = 0;
    while (i < text.length) {
        const char = text[i];
        if (inQuotes) {
            if (char === '"') {
                if (text[i + 1] === '"') {
                    field += '"';
                    i++;
                } else {
                    inQuotes = false;
                }
            } else {
                field += char;
            }
        } else {
            if (char === '"') {
                inQuotes = true;
            } else if (char === ',') {
                row.push(field);
                field = '';
            } else if (char === '\n' || char === '\r') {
                // Handle CRLF or LF
                if (field !== '' || row.length > 0) row.push(field);
                field = '';
                if (row.length > 0) rows.push(row);
                row = [];
                // Skip \r\n
                if (char === '\r' && text[i + 1] === '\n') i++;
            } else {
                field += char;
            }
        }
        i++;
    }
    // Add last field
    if (field !== '' || row.length > 0) {
        row.push(field);
        rows.push(row);
    }
    return rows;
}
function parseCSV( lines ) {
	let out = [];
	for( let l of lines ) {
		out.push( CSVtoArray(l) );
	}
	return out;
}

function parseJSON(lines) {
	try {
		let out = [];
		for (let l of lines) {
			out.push(JSON.parse(l));
		}
		return out;
	}
	catch (e) { return null }
}

function sourceField( v ) {
	console.log( 'sourceField', v )
	if( v.match(/^s3:\/\//) ) return 2;
	if( v.match(/^https:\/\//) ) return 1;
	if( v.match(/^http:\/\//) ) return 1;
	return 0;
}

var datasetcompany = null;
var datasetId = null;
var datasetName = null;
function DatasetUpload(prop) {

    var global = window.GlobalVars;


	if( !window.GlobalVars.PDFProjectCompany ) window.GlobalVars.PDFProjectCompany = window.GlobalVars.userCompany;
	global.currentFileDataset  = [global.PDFProjectCompany,global.PDFProjectId,global.PDFProjectName].join('|');
	[datasetcompany,datasetId,datasetName] = global.currentFileDataset ? global.currentFileDataset.split('|') : [null,null,null];


    // function drawLoadS3Bucket() {
    //     var content = '<input type="text" placeholder="Enter S3 Bucket"> <button class="btn btn-primary">Add S3 Bucket Content</button>';
    // }

	function draw() {
		if( !window.GlobalVars.currentDataset.descriptor ) window.GlobalVars.currentDataset.descriptor = {};
		[datasetcompany, datasetId, datasetName] = global.currentFileDataset ? global.currentFileDataset.split('|') : [null, null, null];
		// var extensions = ['jpg','png', 'jpeg', 'tif', 'tiff', 'pdf', 'wav', 'mp3', 'mp4'];
		var extensions = ['jpg', 'png', 'jpeg', 'tif', 'tiff'];
		if (global.currentDataset.datasetType == 'Text') extensions = ['txt'];
		else if (global.currentDataset.datasetType == 'PDFOCR') extensions = ['pdf','jpg', 'png', 'jpeg', 'tif', 'tiff'];
		else if (global.currentDataset.datasetType == 'PDFImage') extensions = ['jpg', 'png', 'jpeg', 'tif', 'tiff'];
		else if (global.currentDataset.datasetType == 'PDF') extensions = ['pdf'];
		else if (global.currentDataset.datasetType == 'Audio') extensions = ['wav', 'mp3'];
		else if (global.currentDataset.datasetType == 'Video') extensions = ['mp4'];
		else if (global.currentDataset.datasetType == 'Csv') extensions = ['csv'];
		ext = '.' + extensions.join(',.');
		allowed = new RegExp('.(' + extensions.join('|') + ')$', 'i')
		// alert( allowed )
		var upfilebtn = $('<button id="uploadfiles" type="submit" class="ml-2 mt-2 btn btn-pink">Select Files</button>')
		var upfileSepbtn = $('<button id="uploadfilesseparate" type="submit" class="ml-2 mt-2 btn btn-pink">Select Files Make Separate</button>')
		$('#topbuttons').append( upfilebtn )
		var upfolderbtn = $('<button id="uploadfolder" type="submit" class="ml-2 mt-2 btn btn-pink">Select Folder</button>')
		var upcloudbtn = $('<button id="uploadcloud" type="submit" class="ml-2 mt-2 btn btn-pink">Select From Cloud</button>')
		var upmanifestbtn = $('<button id="uploadmanifest" type="submit" class="ml-2 mt-2 btn btn-pink">Select Manifest/CSV/TXT</button>')
		var actbutton = $('<button id="actionButton" type="submit" class="ml-2 mt-2 btn btn-pink" style="float: right; display:none">Action <i class="fa fa-caret-down"></i></button>')
		actbutton.on('click', actionPopup);
		var douploadbtn = $('<button id="uploadbutton" type="submit" class="ml-2 mt-2 btn btn-primary" style="float: right">Upload All Files</button>')
		$('#topbuttons').append( upfilebtn, upfolderbtn, upcloudbtn, upmanifestbtn, douploadbtn, actbutton )
		// upcloudbtn.hide();
		douploadbtn.on('click', function(){submitFiles()} )
		if (global.currentDataset.datasetType == 'Csv')
        {
            $('#topbuttons').append( upfileSepbtn )
        }
        else{
            $("uploadfilesseparate").hide()
        }
		upcloudbtn.on('click', cloudupload )
		setUpload(upfilebtn, {
			multiple: '',
		}, ext, function(files){
			for( let f of files ) {
				addFile( f )
			}
			tabRedraw();	
		});

		setUpload(upfileSepbtn, {
    multiple: '',
}, ext, async function(files) {
    let itemsToAdd = [];
    const processingPromises = Array.from(files).map(f => {
        return new Promise((resolve) => {
            if (f.name && f.name.toLowerCase().endsWith('.csv')) {
                const reader = new FileReader();
                reader.onload = function(event) {
                    const content = event.target.result;
                    const data = parseCSVt(content);

                    // If CSV is empty or just has a header, resolve with an empty array
                    if (!data || data.length < 2) {
                        console.warn('CSV file is empty or contains only a header row.', f.name);
                        return resolve([]);
                    }

                    const header = data[0];
                    const dataRows = data.slice(1);
					console.log(header,dataRows);
					
                    const rowObjects = dataRows.map((row, index) => {
                        const csvContent = [header, row]
                            .map(rowData => rowData.map(cell => {
                                const cellStr = String(cell || '');
                                
                                if (cellStr.includes(',') || cellStr.includes('"') || cellStr.includes('\n')) {
                                    return '"' + cellStr.replace(/"/g, '""') + '"';
                                }
                                return cellStr;
                            }).join(','))
                            .join('\n');
							var saltfr = Math.random();
                        const itemName = `Row ${index + 1}-${saltfr}-${f.name}`;
                        console.log(itemName);
                        console.log('CSV Content:', csvContent);

                        // Create CSV blob - pure CSV text
                        const blob = new Blob([csvContent], { type: 'text/csv' });
                        
                        const fileForRow = new File([blob], itemName, {
                            type: 'text/csv',
                            lastModified: f.lastModified,
                        });
                        return fileForRow;
                    });
                    resolve(rowObjects);
                };
                reader.onerror = function(err) {
                    console.error("Error reading file:", f.name, err);
                    resolve([]); // Resolve with empty array on error to not block other files
                };
                reader.readAsText(f);
            } else {
                resolve([f]);
            }
        });
    });

    // Wait for all files (and CSV rows) to be processed
    const results = await Promise.all(processingPromises);
    itemsToAdd = results.flat(); // .flat() combines the arrays of row objects into one list

    // Add all processed items to the main upload list
    for (const item of itemsToAdd) {
        addFile(item);
    }
    tabRedraw();
		});
		setUpload(upfolderbtn, {
			webkitdirectory: '',
			directory: '',
		}, ext, function(files){
			for( let f of files ) {
				addFile( f )
			}
			tabRedraw();	
		});	
		let maniExt =  '.' + ['manifest','csv','txt'].join(',.');
		setUpload(upmanifestbtn, {
		}, maniExt, function (files) {
			console.log('MANI', files)
			const reader = new FileReader();

			reader.addEventListener('load', async (event) => {
				const content = event.target.result;
				// Do something with the file content
				// console.log('CONTENT', content)
				uploadFileList( content );
			});
			reader.readAsText(files[0]);
		})
		drawTable();
	}


    useEffect( function(a){
		setTimeout(() => {
			draw();
		}, 1000);
    });


	return (
		<div fluid="md p-0" className="maincontent">
			<div id="topbuttons"></div>
			<div id="dashboard"></div>
			<Table id="documentlist" bordered hover size="sm" className="table-grid mt-3">
			</Table>
			<span>&nbsp;</span>
		</div>
	);
}



export default DatasetUpload
